import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import {
    IDynamicProfilingRequest,
    IDynamicProfilingPostData,
    IDynamicProfilingData,
    IDynamicProfilingRemoveSuccess,
} from '@/types/types';

const makeDynamicProfilingService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);
    const downloadFileFetcher = makeFetcher(apiUrl, {
        headers: {
            Accept: 'text/csv',
            'Content-Type': 'text/csv;charset=UTF-8',
        },
        mode: 'cors',
        credentials: 'include',
    });

    return {
        getData: async (reqData: {
            attributes: string[];
            path: string;
            postData?: IDynamicProfilingPostData;
            sessionId?: number;
            userId?: string;
            surveyKey?: string;
        }) => {
            const requestData: IDynamicProfilingRequest = {
                attributes: reqData.attributes,
                clientLocation: reqData.path,
                placeId: config.placeId,
                sessionId: reqData.sessionId,
                postData: reqData.postData,
                userId: reqData.userId,
                surveyKey: reqData.surveyKey,
            };
            const res = await fetcher.post('/widget', JSON.stringify(requestData));
            const data = (await res.json()) as Promise<IDynamicProfilingData>;
            return data;
        },

        exportProfile: async (language: string) => {
            return await downloadFileFetcher.get(`?attributes=language|${language}`);
        },

        deleteProfile: async () => {
            const res = await fetcher.delete();
            const data = (await res.json()) as Promise<IDynamicProfilingRemoveSuccess>;
            const { successMessage } = await data;
            return successMessage;
        },
    };
};

export const dynamicProfilingService = makeDynamicProfilingService(config.api.url.dynamicProfiling);
